export default {
    apiKey: "AIzaSyB4Q-JdCOHlWvj6r_kaSR8syN3iAni3ODg",
    authDomain: "ich-lerne-deutsch.firebaseapp.com",
    databaseURL: "https://ich-lerne-deutsch.firebaseio.com",
    projectId: "ich-lerne-deutsch",
    storageBucket: "ich-lerne-deutsch.appspot.com",
    messagingSenderId: "274625369412"
}
